<template>
  <div>
    <!-- <sidebar> -->
    <div class="sidebar" id="sidebar">
      <div class="sidebar-inner" id="style-15">
        <vue-custom-scrollbar
          class="scroll-area"
          :settings="settings"
          @ps-scroll-x="scrollHanle"
        >
          <div id="sidebar-menu" class="sidebar-menu">
            <ul>
              <li class="menu-title">
                <span>My Dashboard</span>
              </li>
              <li class="policies" v-if="currentUser.employee.status == 3">
                <router-link to="/onboard-detail"
                  ><i class="fa fa-user"></i> <span>Onboard</span></router-link
                >
              </li>
              <li class="policies">
                <router-link to="/profile"
                  ><i class="fa fa-user"></i> <span>Profile</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/attendance-employee"
                  ><i class="fa fa-pencil"></i>
                  <span>Attendance</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/colleagues"
                  ><i class="fa fa-users"></i>
                  <span>Colleagues</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/leave-request"
                  ><i class="fa fa-hand-paper-o"></i>
                  <span>Leave Request</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/resignationEmployee"
                  ><i class="fa fa-briefcase"></i>
                  <span>Resignation Request</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/retirementEmployee"
                  ><i class="fa fa-hourglass-end"></i>
                  <span>Retirement Request</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/expense-claims-employee"
                  ><i class="fa fa-ticket"></i>
                  <span>Expense Claim</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/cash-advance-employee"
                  ><i class="fa fa-ticket"></i>
                  <span>Cash Advance</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/store-requisition-employee"
                  ><i class="fa fa-ticket"></i>
                  <span>Store Requisition</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/purchase-requisition-employee"
                  ><i class="fa fa-ticket"></i>
                  <span>Purchase Requisition</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/payslip-employee">
                  <i class="fa fa-money"></i>
                  <span>Salary</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/loan-request">
                  <i class="fa fa-money"></i>
                  <span>Loan Request</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/my-performance-goals">
                  <i class="fa fa-building"></i>
                  <span>My Goals</span></router-link
                >
              </li>

              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isMgt"
              >
                <router-link to="/mgt-review">
                  <i class="fa fa-users"></i>
                  <span>All Employee Reviews</span></router-link
                >
              </li>
              <!-- / -->
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/employee-disciplinary-case">
                  <i class="fa fa-file-archive-o"></i>
                  <span>Disciplinary Case</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.employee.status != 3">
                <router-link to="/training-needs">
                  <i class="fa fa-envelope-open"></i>
                  <span>Training Needs</span></router-link
                >
              </li>
              <li
                class="menu-title"
                v-if="currentUser.employee.status != 3 && (isManager || isOptManager)"
              >
                <span>My Team</span>
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isManager"
              >
                <router-link to="/leavesByManager">
                  <i class="fa fa-building-o"></i>
                  <span>Team Leaves</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isManager"
              >
                <router-link to="/team-performance-goals">
                  <i class="fa fa-building-o"></i>
                  <span>Team Goals</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isOptManager"
              >
                <router-link to="/expense-claims-manager">
                  <i class="fa fa-building-o"></i>
                  <span>Team Expense</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isOptManager"
              >
                <router-link to="/approved-expense-claims-manager">
                  <i class="fa fa-building-o"></i>
                  <span>Team Approved Expense</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isOptManager"
              >
                <router-link to="/cash-advance-manager">
                  <i class="fa fa-building-o"></i>
                  <span>Team Cash Advance</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isOptManager"
              >
                <router-link to="/approved-cash-advance-manager">
                  <i class="fa fa-building-o"></i>
                  <span>Team Approved Cash Advance</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isManager"
              >
                <router-link to="/team-loan-request">
                  <i class="fa fa-money"></i>
                  <span>Team Loan Request</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isOptManager"
              >
                <router-link to="/store-requisition-manager">
                  <i class="fa fa-bank"></i>
                  <span>Team Store Req</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isOptManager"
              >
                <router-link to="/purchase-requisition-manager">
                  <i class="fa fa-bank"></i>
                  <span>Team Purchase Req</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isManager"
              >
                <router-link to="/manager-review">
                  <i class="fa fa-building-o"></i>
                  <span>Team Reviews</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isManager"
              >
                <router-link to="/leave-approvals">
                  <i class="fa fa-money"></i>
                  <span>Team Leave Approval Record</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isManager"
              >
                <router-link to="/loan-approvals">
                  <i class="fa fa-money"></i>
                  <span>Team Loan Approval Record</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.employee.status != 3 && isManager"
              >
                <router-link to="/team-training-needs">
                  <i class="fa fa-handshake-o"></i>
                  <span>My Team Training Needs</span></router-link
                >
              </li>
              <li
                class="menu-title"
                v-if="
                  currentUser.employee.designation.departmentId === 14
                "
              >
                <span>Training</span>
              </li>
              <li
                class="submenu"
                v-if="
                  currentUser.employee.designation.departmentId === 14
                "
              >
                <a href="#"
                  ><i class="la la-file-pdf-o"></i> <span> Training </span>
                  <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <li class="policies">
                    <router-link to="/confirmed-training-needs">
                      <span>Training Needs</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/training-plan">
                      <span>Training Plan</span></router-link
                    >
                  </li>
                  <!-- <li class="policies">
                <router-link to="/group-training-plan"
                  >
                  <span>Group Training Plan</span></router-link
                >
              </li> -->
                  <li class="policies">
                    <router-link to="/training-program">
                      <span>Training Program</span></router-link
                    >
                  </li>
                  <li class="policies">
                    <router-link to="/training-provider">
                      <span>Training Providers</span></router-link
                    >
                  </li>
                </ul>
              </li>
              <li
                class="submenu"
                v-if="
                  currentUser.employee.designation.departmentId === 14
                "
              >
                <a href="#"
                  ><i class="la la-cog"></i> <span> Skill Settings </span>
                  <span class="menu-arrow"></span
                ></a>
                <ul style="display: none">
                  <li class="promotion">
                    <router-link to="/skill"> <span>Skills</span></router-link>
                  </li>
                  <li class="resignation">
                    <router-link to="/skill-type">
                      <span>Skill Types</span></router-link
                    >
                  </li>
                  <li class="termination">
                    <router-link to="/skill-grade">
                      <span>Skill Grades</span></router-link
                    >
                  </li>
                  <li class="termination">
                    <router-link to="/skill-gap">
                      <span>Skill Gap</span></router-link
                    >
                  </li>
                </ul>
              </li>
              <li class="menu-title" v-if="currentUser.roles.includes('HOD') || currentUser.roles.includes('HOU')">
                <span>HOU/HOD Approval</span>
              </li>
              <li class="policies" v-if="currentUser.roles.includes('HOD') || currentUser.roles.includes('HOU')">
                <router-link to="/departleaves">
                  <i class="fa fa-handshake-o"></i>
                  <span>Leave</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.roles.includes('HOD') || currentUser.roles.includes('HOU')">
                <router-link to="/probatedstafflist">
                  <i class="fa fa-handshake-o"></i>
                  <span>Probation List</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.roles.includes('HOD') || currentUser.roles.includes('HOU')">
                <router-link to="/transferedstafflist">
                  <i class="fa fa-handshake-o"></i>
                  <span>Transfered Employees</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.roles.includes('HOD') || currentUser.roles.includes('HOU')">
                <router-link to="/incomingstafflist">
                  <i class="fa fa-handshake-o"></i>
                  <span>Incoming Employees</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.roles.includes('HOD') || currentUser.roles.includes('HOU')">
                <router-link to="/agm-loan-request">
                  <i class="fa fa-money"></i>
                  <span>Loan Requests</span></router-link
                >
              </li>

              <li class="menu-title" v-if="currentUser.roles.includes('GMD')">
                <span>GMD Approval</span>
              </li>
              <!-- <li class="policies" v-if="currentUser.roles.includes('GMD')">
                <router-link to="/jobprofileGMD">
                  <i class="fa fa-handshake-o"></i>
                  <span>Job Profile</span></router-link
                >
              </li> -->
              <li class="policies" v-if="currentUser.roles.includes('GMD')">
                <router-link to="/departApprovedByGMD">
                  <i class="fa fa-handshake-o"></i>
                  <span>Departments</span></router-link
                >
              </li>

              <li class="policies" v-if="currentUser.roles.includes('GMD')">
                <router-link to="/designationApprovedByGMD">
                  <i class="fa fa-handshake-o"></i>
                  <span>Designations</span></router-link
                >
              </li>

              <li class="policies" v-if="currentUser.roles.includes('GMD')">
                <router-link to="/companyUnitsApprovedByGMD">
                  <i class="fa fa-handshake-o"></i>
                  <span>Company Units</span></router-link
                >
              </li>


              <li
                class="menu-title"
                v-if="currentUser.roles.includes('CASHIER')"
              >
                <span>Cashier</span>
              </li>
              <li class="policies" v-if="currentUser.roles.includes('CASHIER')">
                <router-link to="/expense-claims-cashier">
                  <i class="fa fa-ticket"></i>
                  <span>Expense Claims</span></router-link
                >
              </li>
              <li class="policies" v-if="currentUser.roles.includes('CASHIER')">
                <router-link to="/cash-advance-cashier">
                  <i class="fa fa-ticket"></i>
                  <span>Cash Advances</span></router-link
                >
              </li>
              <li
                class="menu-title"
                v-if="currentUser.roles.includes('STORE OFFICER')"
              >
                <span>Store</span>
              </li>
              <li
                class="policies"
                v-if="currentUser.roles.includes('STORE OFFICER')"
              >
                <router-link to="/store-requisition-store">
                  <i class="fa fa-ticket"></i>
                  <span>Store Requisitions</span></router-link
                >
              </li>
              <li
                class="menu-title"
                v-if="currentUser.roles.includes('REQUISITION OFFICER')"
              >
                <span>Requisition</span>
              </li>
              <li
                class="policies"
                v-if="currentUser.roles.includes('REQUISITION OFFICER')"
              >
                <router-link to="/store-requisition-store">
                  <i class="fa fa-ticket"></i>
                  <span>Store Requisitions</span></router-link
                >
              </li>
              <li
                class="policies"
                v-if="currentUser.roles.includes('REQUISITION OFFICER')"
              >
                <router-link to="/purchase-requisition-req">
                  <i class="fa fa-ticket"></i>
                  <span>Purchase Requisitions</span></router-link
                >
              </li>
            </ul>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <!-- </sidebar> -->
  </div>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import { authenticationService } from "@/services/authenticationService";
import { employeeService } from "@/services/employeeService.js";

export default {
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      settings: {
        suppressScrollX: false
      },
      activeClass: "active",
      currentUser: authenticationService.currentUserValue,
      isManager: false,
      isOptManager: false,
      isMgt: false
    };
  },
  mounted() {
    this.isEmployeeManager();
    this.isOperationalEmployeeManager();
    this.checkMgt();
    $("#sidebar-menu a").on("click", function(e) {
      if (
        $(this)
          .parent()
          .hasClass("submenu")
      ) {
        e.preventDefault();
      }
      if (!$(this).hasClass("subdrop")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideDown(350);
        $(this).addClass("subdrop");
      } else if ($(this).hasClass("subdrop")) {
        $(this).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideUp(350);
      }
    });
    $("#sidebar-menu ul li.submenu a.active")
      .parents("li:last")
      .children("a:first")
      .addClass("active")
      .trigger("click");
  },
  computed: {
    currentpage() {
      return this.$route.path;
    }
  },
  methods: {
    isEmployeeManager() {
      employeeService.isEmployeeManager().then(model => {
        this.isManager = model;
      });
    },
    isOperationalEmployeeManager() {
      employeeService.isOperationalEmployeeManager().then(model => {
        this.isOptManager = model;
      });
    },
    checkMgt() {
      var employeeId = this.currentUser.employee.id;
      employeeService.checkMgt(employeeId).then(model => {
        this.isMgt = model;
      });
    },
    scrollHanle(evt) {
      // console.log(evt);
    }
  }
};
</script>
<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}
/* .ps__rail-y {
        top: 0px !important;
    height: 657px !important;
    right: -3px !important;
    background-color: transparent !important;
        } */
</style>



// WEBPACK FOOTER //
// src/components/layouts/employeeSidebar.vue